import { Outlet, Navigate } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import { BookOpen, Gift, Tag, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AdminLayout() {
  const token = localStorage.getItem('admin_token');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    window.location.href = '/admin/login';
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-muted">
      {/* Admin Navigation */}
      <nav className="bg-card border-b border-border">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/admin" className="font-heading text-2xl font-light text-primary">
              what2gift Admin
            </Link>
            <Button onClick={handleLogout} variant="ghost" size="sm" data-testid="admin-logout-button">
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </nav>

      <div className="container mx-auto px-6 py-8">
        <div className="flex gap-6">
          {/* Sidebar */}
          <aside className="w-64 bg-card rounded-lg border border-border p-6 h-fit">
            <nav className="space-y-2">
              <Link
                to="/admin/books"
                className={`flex items-center gap-3 px-4 py-2 rounded-md transition-all ${
                  isActive('/admin/books')
                    ? 'bg-primary text-primary-foreground'
                    : 'hover:bg-secondary'
                }`}
                data-testid="admin-nav-books"
              >
                <BookOpen className="h-5 w-5" />
                <span className="font-body">Manage Books</span>
              </Link>
              <Link
                to="/admin/gifts"
                className={`flex items-center gap-3 px-4 py-2 rounded-md transition-all ${
                  isActive('/admin/gifts')
                    ? 'bg-primary text-primary-foreground'
                    : 'hover:bg-secondary'
                }`}
                data-testid="admin-nav-gifts"
              >
                <Gift className="h-5 w-5" />
                <span className="font-body">Manage Gifts</span>
              </Link>
              <Link
                to="/admin/categories"
                className={`flex items-center gap-3 px-4 py-2 rounded-md transition-all ${
                  isActive('/admin/categories')
                    ? 'bg-primary text-primary-foreground'
                    : 'hover:bg-secondary'
                }`}
                data-testid="admin-nav-categories"
              >
                <Tag className="h-5 w-5" />
                <span className="font-body">Manage Categories</span>
              </Link>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="flex-1">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}